import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, Button, Message, Table } from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import { getContractorsStatus, getBookbankStatus } from '../../redux/actions/contract'
import { Link } from 'react-router-dom'
import COIValidateWidget from '../coi/COIValidateWidget'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'
import CancelApprovalList from '../../components/modal/ApproverListModal/CancelApprovalList'
import FetchNewApprover from '../../components/modal/ApproverListModal/FetchNewApprover'

export default function ContractSigningWidgets({
  schema,
  schemaButton,
  onSuccess = () => {},
  isBookbank,
  isShowCoiBox = false,
}) {
  const [formSchema, setFormSchema] = useState(schema)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isSignSuccessful, setIsSignSuccessful] = useState(false)
  const { Column, HeaderCell, Cell } = Table
  const [isCheckCOI, setIsCheckCOI] = useState(false)
  const [isCOIPass, setIsCOIPass] = useState(false)
  const [checkCOI, setCheckCOI] = useState(false)
  const [checkInterest, setCheckInterest] = useState(false)
  const [showCOIDetail, setShowCOIDetail] = useState(false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (formSchema?.contractorList.length > 0) {
      let isSignAll = true
      formSchema?.contractorList.forEach((item) => {
        if (!item.signedDate) {
          isSignAll = false
        }
      })
      if (isSignAll) {
        console.log('sign all success !!')
        setIsSignSuccessful(true)
      }
    }
  }, [formSchema])

  const handleOnClickCheckSigning = () => {
    handleCallService(projectId)
  }

  const handleCallService = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      console.log('call service')
      var response
      if (isBookbank) {
        response = await getBookbankStatus(projectVersionId)
      } else {
        response = await getContractorsStatus(projectVersionId)
      }

      console.log('response', response)

      setFormSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setIsError(e.response.data.errors?.message)
      } else {
        setIsError('ไม่สำเร็จ')
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel
        className="grantee-profile-info"
        shaded
        header={formSchema.panelText}
        bordered
        collapsible
        defaultExpanded
        style={{ marginBottom: 10 }}
      >
        {!isSignSuccessful && (
          <>
            {isError && <Message showIcon type="error" description={isError} />}
            <Button
              style={{ width: 'auto' }}
              // appearance="ghost"
              color="rgb(45, 168, 136)"
              appearance="primary"
              onClick={handleOnClickCheckSigning}
              disabled={isLoading}
            >
              {'ตรวจสอบการลงนาม'}
            </Button>
            <br />
            <br />
            <Link onClick={() => window.open(`${process.env.REACT_APP_ESIGNATURE_URL}`)}>
              ไปยังระบบลงลายมือชื่ออิเล็กทรอนิกส์ (e-Signature)
            </Link>
            <br />
            <br />
          </>
        )}

        <Table autoHeight data={formSchema.contractorList}>
          <Column width={69} align="center">
            <HeaderCell>
              <span>ลำดับ</span>
            </HeaderCell>
            {/* <Cell dataKey="no" /> */}
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>
          <Column minWidth={250} flexGrow={1}>
            <HeaderCell>
              <span>ชื่อ-สกุลผู้ลงนาม</span>
            </HeaderCell>
            <Cell dataKey="name" />
          </Column>
          <Column minWidth={200} flexGrow={1}>
            <HeaderCell>
              <span>ประเภทผู้ลงนาม</span>
            </HeaderCell>
            <Cell dataKey="contractorType" />
          </Column>
          <Column minWidth={200} flexGrow={1}>
            <HeaderCell>
              <span>email</span>
            </HeaderCell>
            <Cell dataKey="email" />
          </Column>
          <Column minWidth={200} flexGrow={1}>
            <HeaderCell>
              <span>วันที่ลงนาม</span>
            </HeaderCell>
            <Cell dataKey="signedDate" />
          </Column>
        </Table>

        {isShowCoiBox && (
          <div style={{ marginTop: 30 }}>
            <COIValidateWidget
              // disabled={disabled || !showCommandButton}
              setIsCOIPass={setIsCOIPass}
              checkCOI={checkCOI}
              setCheckCOI={setCheckCOI}
              setIsCheckCOI={setIsCheckCOI}
              setCheckInterest={setCheckInterest}
              checkInterest={checkInterest}
              fixType={'10'}
              hideCheckCOI
            />
          </div>
        )}
      <br/>
        {schemaButton?.checkButton && (
          <ApproverList
            approveType={11}
            projectversionId={projectId}
            style={{ marginLeft: 10 }}
            buttontext={schemaButton?.checkButton}
            isLoading={isLoading}
            fetchButton={(disabled) =>
              schemaButton?.fetchButton && (
                <FetchNewApprover
                  approveType={11}
                  projectversionId={projectId}
                  style={{ marginRight: 10, marginBottom: 10 }}
                  buttontext={schemaButton?.fetchButton}
                  onSuccess={onSuccess}
                  disabled={disabled}
                />
              )
            }
          />
        )}
        {schemaButton?.cancelButton && (
          <CancelApprovalList
            approveType={11}
            projectversionId={projectId}
            style={{ marginRight: 10, marginLeft: 10 }}
            buttontext={schemaButton?.cancelButton}
            onSuccess={onSuccess}
          />
        )}
      </Panel>
    </>
  )
}
